import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { ItineraryService } from '../../search-result/services/itinerary.service';
import { OperationLogService } from '../../search-result/services/operation-log.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';

function loadOperations(
  pnr: string,
  gds: string,
  api: APIService,
  layoutService: LayoutService,
  operationService: OperationLogService,
  itineraryService: ItineraryService
) {
  return api.getOperations(pnr).pipe(
    map((response) => {
      layoutService.dispatchChangeBreadcrumb(pnr, OptionType.Log);
      operationService.dispatchLoadOperationsSuccess(response);
      return !!response;
    }),
    catchError((response) => {
      itineraryService.dispatchGenericError(response);
      itineraryService.navigateToWithParams('itinerary/info');
      return of(false);
    })
  );
}

export const OperationLogGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const api = inject(APIService);
  const itineraryService = inject(ItineraryService);
  const operationService = inject(OperationLogService);
  const layoutService = inject(LayoutService);

  return loadOperations(
    route?.queryParams?.pnr,
    route?.queryParams?.gds,
    api,
    layoutService,
    operationService,
    itineraryService
  );
};
